import TYPE from "../../constants/type";
import { apiCall } from "../../utils/api";
import { notification } from "../home/action";
import { API_URLS } from "../../constants/api";
import { PREFIX } from "../../constants/enums";

export const getAllPresentation = () => async (dispatch) => {
  const api = API_URLS.PRESENTATION.getAllPresentation();
  dispatch({
    type: TYPE.PRESENTATION.GET_ALL_PRESENTATION_LOADING,
    meta: { prefix: [PREFIX.PRESENTATION, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.PRESENTATION.GET_ALL_PRESENTATION_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.PRESENTATION, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.PRESENTATION.GET_ALL_PRESENTATION_FAILURE,
      meta: { prefix: [PREFIX.PRESENTATION, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Lấy dữ liệu thất bại!",
      })
    );
  }
};

export const getFilteredPresentation = (page, pageSize, payload) => async (dispatch) => {
  const api = API_URLS.PRESENTATION.getFilteredPresentation(page, pageSize);
  dispatch({
    type: TYPE.PRESENTATION.GET_FILTERED_PRESENTATION_LOADING,
    meta: { prefix: [PREFIX.PRESENTATION, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.PRESENTATION.GET_FILTERED_PRESENTATION_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.PRESENTATION, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.PRESENTATION.GET_FILTERED_PRESENTATION_FAILURE,
      meta: { prefix: [PREFIX.PRESENTATION, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Lấy dữ liệu thất bại!",
      })
    );
  }
};

export const getAllPresentationByProfileId = (id) => async (dispatch) => {
  const api = API_URLS.PRESENTATION.getAllPresentationByProfileId(id);
  dispatch({
    type: TYPE.PRESENTATION.GET_ALL_PRESENTATION_BY_PROFILE_ID_LOADING,
    meta: { prefix: [PREFIX.PRESENTATION, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.PRESENTATION.GET_ALL_PRESENTATION_BY_PROFILE_ID_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.PRESENTATION, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.PRESENTATION.GET_ALL_PRESENTATION_BY_PROFILE_ID_FAILURE,
      meta: { prefix: [PREFIX.PRESENTATION, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Lấy dữ liệu thất bại!",
      })
    );
  }
};

export const insertPresentation = (profileId, payload) => async (dispatch) => {
  const api = API_URLS.PRESENTATION.insertPresentation();
  dispatch({
    type: TYPE.PRESENTATION.INSERT_PRESENTATION_LOADING,
    meta: { prefix: [PREFIX.PRESENTATION, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.PRESENTATION.INSERT_PRESENTATION_SUCCESS,
      id: profileId,
      payload: response.data.data,
      meta: { prefix: [PREFIX.PRESENTATION, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Thêm dữ liệu thành công!",
      })
    );
    return { success: true, data: response.data.data };
  } else {
    dispatch({
      type: TYPE.PRESENTATION.INSERT_PRESENTATION_FAILURE,
      meta: { prefix: [PREFIX.PRESENTATION, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Thêm dữ liệu thất bại!",
      })
    );
    return { success: false, data: null };
  }
};

export const updatePresentation = (id, payload) => async (dispatch) => {
  const api = API_URLS.PRESENTATION.updatePresentation(id);
  dispatch({
    type: TYPE.PRESENTATION.UPDATE_PRESENTATION_LOADING,
    meta: { prefix: [PREFIX.PRESENTATION, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.PRESENTATION.UPDATE_PRESENTATION_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.PRESENTATION, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Cập nhật dữ liệu thành công!",
      })
    );
    return true;
  } else {
    dispatch({
      type: TYPE.PRESENTATION.UPDATE_PRESENTATION_FAILURE,
      meta: { prefix: [PREFIX.PRESENTATION, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Cập nhật dữ liệu thất bại!",
      })
    );
    return false;
  }
};

export const deletePresentation = (id) => async (dispatch) => {
  const api = API_URLS.PRESENTATION.deletePresentation(id);
  dispatch({
    type: TYPE.PRESENTATION.DELETE_PRESENTATION_LOADING,
    meta: { prefix: [PREFIX.PRESENTATION, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.PRESENTATION.DELETE_PRESENTATION_SUCCESS,
      id,
      meta: { prefix: [PREFIX.PRESENTATION, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Xoá dữ liệu thành công!",
      })
    );
    return true;
  } else {
    dispatch({
      type: TYPE.PRESENTATION.DELETE_PRESENTATION_FAILURE,
      meta: { prefix: [PREFIX.PRESENTATION, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Xoá dữ liệu thất bại!",
      })
    );
    return false;
  }
};

// Sprint 2: admin "Yêu cầu khai lại" for presentation.
export const requestRevisionPresentation = (id, reason) => async (dispatch) => {
  const api = API_URLS.PRESENTATION.requestRevisionPresentation(id);
  const { response, error } = await apiCall({ ...api, payload: { reason } });
  if (!error && response?.status === 200 && response.data?.success) {
    if (response.data.data) {
      dispatch({
        type: TYPE.PRESENTATION.ACCEPT_PRESENTATION_SUCCESS,
        payload: response.data.data,
        meta: { prefix: [PREFIX.PRESENTATION, PREFIX.API_SUCCESS] },
      });
    }
    dispatch(notification({ type: 'success', message: 'Đã gửi yêu cầu khai lại' }));
    return true;
  }
  dispatch(notification({
    type: 'error',
    message: response?.data?.message || 'Yêu cầu khai lại thất bại',
  }));
  return false;
};

export const acceptPresentation = (id, accept) => async (dispatch) => {
  const api = API_URLS.PRESENTATION.acceptPresentation(id, accept);
  dispatch({
    type: TYPE.PRESENTATION.ACCEPT_PRESENTATION_LOADING,
    meta: { prefix: [PREFIX.PRESENTATION, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.PRESENTATION.ACCEPT_PRESENTATION_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.PRESENTATION, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Xác nhận thành công!",
      })
    );
    return true;
  } else {
    dispatch({
      type: TYPE.PRESENTATION.ACCEPT_PRESENTATION_FAILURE,
      meta: { prefix: [PREFIX.PRESENTATION, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Xác nhận thất bại!",
      })
    );
    return false;
  }
};

